module.exports = __webpack_public_path__ + "img/chatBg.7cc7d58d.png";